import { FetchResourceOK } from '../types/FetchResourceOK'
import { Resource } from '../types/Resource'
import guards from '.'

 
export default <R extends Resource>(japiDocument: any): japiDocument is FetchResourceOK<R> => typeof japiDocument === 'object' && ! guards.isErrorDocument(japiDocument) && 'data' in japiDocument && (japiDocument.data === null || typeof japiDocument.data.type === 'string')
